import "./eventCard.css";
import React from "react";
import moment from "moment";
import { FaUserCheck } from "react-icons/fa";
import helperService from "../../services/helper.service";

function EventCard({ event, currentMode, handleViewEvent }) {
	return (
		<>
			<div
				className={`event_card ${event?.status} ${currentMode}`}
				onClick={() => handleViewEvent(event)}
			>
				<div className="event_card_header">
					<div className="event_card_header_for_event_and_time">
						<h3>{event?.title}</h3>
						{currentMode === "year" ? (
							<p>{moment.utc(event?.startTime).format("HH:mm")}</p>
						) : null}
					</div>
					<div className="event_card_header_for_icon_and_participants">
						<span className={`event_mode_pill ${event?.eventMode}`}>
							{helperService.capitalize(event?.eventMode)}
						</span>
						<FaUserCheck
							className={`event_card_participate_icon ${event?.status}`}
						/>
						{currentMode === "year" ? (
							<p>
								<strong>{event?.participantsCount}</strong>{" "}
								{event?.participantsCount > 1 ? "Participants" : "Participant"}
							</p>
						) : (
							<p>
								<strong>{event?.participantsCount}</strong>
							</p>
						)}
					</div>
				</div>
				{currentMode === "year" ? (
					<div className="event_card_body">
						<p>{event?.otherDetails || "..."}</p>
					</div>
				) : null}
			</div>
		</>
	);
}

export default EventCard;
